import { Button, Checkbox, Space } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import styles from './index.module.less'
import dangerIcon from '@/assets/dangerIcon.svg'
import { updateChooseFlag } from '@/services/order'
// 可勾选的Button
export default forwardRef(function CheckButton(props: any, ref: any) {
  // const list = props.data
  const { data, setLastChidrenItems, setCurrentValue, defaultValue, budgetId } = props
  const [activeIndex, setActiveIndex] = useState(-1) //当前选中索引
  const [list, setList] = useState<any>([])
  // 1. 数据处理
  useEffect(() => {
    console.log(data, 'data')
    if (data && data.length) {
      let activeIndex = data.findIndex(item => item.id === defaultValue) || 0
      activeIndex = activeIndex !== -1 ? activeIndex : 0
      setActiveIndex(activeIndex)
    }
    setList([...data])
  }, [data])
  useEffect(() => {}, [])
  const butClick = (item, index) => {
    setActiveIndex(index)
  }
  const checkChange = (e, item, index) => {
    let newData = [...list]
    newData[index].object.chooseFlag = e.target.checked
    setList(newData)
    updateChooseFlag({
      data: {
        quoteBudgetId: budgetId,
        itemId: item.id,
        chooseFlag: e.target.checked,
      },
    })
  }
  useEffect(() => {
    console.log(activeIndex, 'activeIndex')
    if (activeIndex !== -1) {
      let newList = [...data]
      if (newList && newList.length) {
        console.log(newList[activeIndex], '选中数据')
        setCurrentValue({ ...newList[activeIndex] })
        // 如果该节点是子项 并且子项下还有项目
        if (
          newList[activeIndex].object?.type === 'PRD_SUB_ITEM' &&
          newList[activeIndex].children?.length
        ) {
          const childrenList = handleCheckButtonData(newList[activeIndex].children)
          setLastChidrenItems([...childrenList])
        }
      }
      setList(newList)
    }
  }, [activeIndex])

  // 处理数据
  const handleCheckButtonData = data => {
    let newList: any = data.map((item: any) => {
      return {
        ...item,
        text: item.label,
        type: 'button',
        checked: item.selected,
        status: '',
      }
    })
    return newList
  }
  useImperativeHandle(ref, () => ({
    activeIndex,
  }))
  return (
    <Space size={[8, 16]} wrap>
      {list &&
        list.length > 0 &&
        list.map((item, index) => {
          if (item.type === 'button') {
            return (
              <Button
                className={`${activeIndex === index ? styles.checkedBorder : ''} flex-center`}
                key={index}
                onClick={() => butClick(item, index)}
              >
                {item.text}
                {item.status && item.status === 'danger' && (
                  <img src={dangerIcon} width={16} style={{ marginLeft: '4px' }} alt="" />
                )}
              </Button>
            )
          } else {
            return (
              <div
                className={`${styles.checkboxOutLook} ${
                  activeIndex === index ? styles.checkedBorder : ''
                }`}
              >
                <Checkbox checked={item.object?.chooseFlag} onChange={e => checkChange(e, item, index)}></Checkbox>
                <div
                  onClick={() => butClick(item, index)}
                  className="flex-center"
                  style={{ marginLeft: '8px' }}
                >
                  <p>{item.text}</p>
                  {item.status && item.status === 'danger' && (
                    <img
                      src={dangerIcon}
                      width={16}
                      style={{ marginLeft: '4px', height: 16 }}
                      alt=""
                    />
                  )}
                </div>
              </div>
            )
          }
        })}
    </Space>
  )
})
